import z from "zod";

const addressSchema = z.object({
  postalCode: z
    .string()
    .regex(/^\d{5}-\d{3}$/, { message: "CEP inválido, formato esperado: 99999-999" })
    .or(z.literal("")),
  street: z.string().min(3, "Rua deve ter ao menos 3 caracteres").max(50),
  number: z.string().min(1, "Número é obrigatório").max(10),
  district: z.string().min(3, "Bairro deve ter ao menos 3 caracteres").max(50),
  city: z.string().min(3, "Cidade deve ter ao menos 3 caracteres").max(50),
  state: z.string().min(2, "Estado inválido").max(50),
  complement: z.string().max(100).optional(),
  reference: z.string().max(50).optional(),
  latitude: z.number().optional().nullable(),
  longitude: z.number().optional().nullable(),
});

type AddressSchemaType = z.infer<typeof addressSchema>;

export {
  addressSchema,
  type AddressSchemaType
};

